/**
 * AgenticFlowBuilderMCP.jsx
 * Wraps the AgenticFlowBuilder with our MCP implementation of context management
 */
import React from 'react';
import AgenticFlowBuilder from './AgenticFlowBuilder';
import { FlowContextProvider, useFlowContext } from '../contexts/FlowContext.jsx';

// Inner component that uses the context, must be rendered inside the provider
function AgenticFlowBuilderWithMCPContext(props) {
  const {
    nodes,
    setNodes,
    edges,
    setEdges,
    getVar,
    setVar,
    deleteVar,
    getAllVars,
    getAllVarsWithMetadata,
    currentNodeId,
    setCurrentNode,
    exportContext,
    importContext,
    // ...other MCP context methods
  } = useFlowContext();

  return (
    <AgenticFlowBuilder
      {...props}
      nodes={nodes}
      setNodes={setNodes}
      edges={edges}
      setEdges={setEdges}
      getVar={getVar}
      setVar={setVar}
      deleteVar={deleteVar}
      getAllVars={getAllVars}
      getAllVarsWithMetadata={getAllVarsWithMetadata}
      currentNodeId={currentNodeId}
      setCurrentNode={setCurrentNode}
      exportContext={exportContext}
      importContext={importContext}
    />
  );
}

function AgenticFlowBuilderMCP(props) {
  return (
    <FlowContextProvider>
      <AgenticFlowBuilderWithMCPContext {...props} />
    </FlowContextProvider>
  );
}

export default AgenticFlowBuilderMCP;
